
























































































































































































// import sjcl from 'sjcl';
import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import LayoutTitle from '@/components/LayoutTitle.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Toggle from '@/components/Toggle.vue';
import Accordion from '@/components/Accordion.vue';
import PermissionTree from '@/components/PermissionTree/PermissionTree.vue';
import { ValidationObserver } from 'vee-validate';
import {
  Group, Role, User,
  PermissionApiResponse,
  UserRoleApiResponse,
  GroupPermissionApiReponse,
  GroupApiResponse,
  ErrorItem,
} from '@/libs/api.interfaces';
import api from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { AxiosError } from 'axios';
import sjcl from 'sjcl';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    Select,
    FormInput,
    SearchIcon,
    LayoutContent,
    Button,
    AddIcon,
    Toggle,
    Checkbox,
    Loader,
    Accordion,
    PermissionTree,
  },
})

export default class UserProfile extends Vue {
  loading = false;
  name = '';
  email = '';
  password = '';
  newPassword = '';
  newPasswordConfirmation = '';

  role: Role | null = null;
  group: Group | null = null;
  detailPermissionProcessed = false;
  groupPermission: string[] = [];
  groupDetailPermission: string[] = [];
  basePermission: PermissionItem[] = [];
  permissions: PermissionItem[] = [];
  groups: Group[] = [];

  twoFactorStatus: null | boolean = null;
  twoFactorStatusChanged = false;
  currentPassword = '';
  qrCode = null;
  twoFactorCode = '';
  loadingTwoFactor = false;

  loadingSubmit = false;

  errors = {
    name: '',
    email: '',
    twoFactor: '',
  };

  mounted() {
    this.getUserData();
  }

  @Watch('twoFactorStatus')
  onTwoFactorStatusChanged(val: boolean, oldVal: null | boolean) {
    if (oldVal === null) return;
    this.twoFactorStatusChanged = true;
  }

  async getUserData() {
    try {
      this.loading = false;
      const { data } = await api.get<User>('/user/profile');
      this.name = data.name;
      this.email = data.email;
      this.role = data.user_role;
      this.group = data.user_role.user_group;
      this.twoFactorStatus = data.use_twofa === 1;
      this.twoFactorStatusChanged = false;

      await this.getPermissions(data.is_internal === 1);
      await this.getRoleDetail();
      await this.getGroups();
      // this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  get roleName() {
    return this.role !== null ? this.role.role : '';
  }

  get groupName() {
    return this.group !== null ? this.group.group : '';
  }

  private async getRoleDetail() {
    try {
      const { data } = await api.get<UserRoleApiResponse>(`/user-role/${this.role?.id}/permissions`);
      this.groupDetailPermission = data.data.items.permission;
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to get user role detail');
    }
  }

  private async getPermissions(isInternal: boolean) {
    try {
      const { data } = await api.get<PermissionApiResponse>('/permissions', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_internal: isInternal,
        },
      });
      const permissions = data.data;
      if (permissions) {
        this.basePermission = permissions;
        this.permissions = permissions;
      }
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to get permission list');
    }
  }

  private async getGroups() {
    try {
      const { data } = await api.get<GroupApiResponse>('/user-groups');
      this.groups = data.data.items;

      if (this.group) {
        this.getGroupPermission(this.group.id);
      }
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to get group list');
    }
  }

  private async getGroupPermission(id: number) {
    try {
      this.permissions = [];

      const { data } = await api.get<GroupPermissionApiReponse>(`/user-group/${id}/permissions`);
      this.groupPermission = data.data.permission;
      this.permissions = this.checkPermission(this.basePermission as PermissionItemCheck[], 0);

      if (!this.detailPermissionProcessed) {
        this.permissions = this.checkPermissionView(this.permissions as PermissionItemCheck[]);
        this.detailPermissionProcessed = true;
      }
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to get group permissions');
    }
  }

  private checkPermissionView(child: PermissionItemCheck[]) {
    const newPermissionsValue = [...child];
    return newPermissionsValue.map((p) => {
      const perm = { ...p };
      if (perm.child) {
        perm.child = this.checkPermissionView(perm.child as PermissionItemCheck[]);
      }

      if (this.groupDetailPermission.includes(perm.value)) {
        perm.checkValue = 'CHECKED';
      } else {
        perm.checkValue = 'UNCHECKED';
      }

      return perm;
    }, [] as PermissionItemCheck[]);
  }

  private checkPermission(child: PermissionItemCheck[], level: number) {
    const newPermissionsValue = [...child];
    return newPermissionsValue.reduce((prev, p) => {
      const perm = { ...p };
      if (perm.child) {
        perm.child = this.checkPermission(perm.child as PermissionItemCheck[], level + 1);
      }

      if (this.groupPermission.includes(perm.value)) {
        perm.checkValue = 'CHECKED';
      }

      if ((perm.checkValue !== undefined || level !== 1)
        && ((perm.child !== undefined && perm.child.length !== 0) || level !== 0)) {
        prev.push(perm);
      }

      return prev;
    }, [] as PermissionItemCheck[]);
  }

  // async updateUser() {
  //   if (this.name === '' || this.email === '') return;

  //   try {
  //     this.loadingSubmit = true;
  //     this.errors = {
  //       name: '',
  //       email: '',
  //     };

  //     /* eslint-disable @typescript-eslint/camelcase */
  //     await api.put('/user/profile', {
  //       name: this.name,
  //       email: this.email,
  //     });
  //     /* eslint-enable @typescript-eslint/camelcase */

  //     showToast(ToastType.SUCCESS, 'Congratulations', 'Your profile has been updated');
  //   } catch (err) {
  //     console.error(err);
  //     const error = err as AxiosError;
  //     showToast(ToastType.FAILED, `Error ${error.response?.status}`,
  // 'Failed to update your profile');

  //     if (error.response?.status === 422) {
  //       err.response.data.error.errors.forEach((item: ErrorItem) => {
  //         if (item.location === 'name') {
  //           this.errors.name = item.message;
  //         } else if (item.location === 'email') {
  //           this.errors.email = item.message;
  //         }
  //       });
  //     } else {
  //       showToast(ToastType.FAILED, `Error ${error.response?.status}`,
  // 'Failed to update your profile');
  //     }
  //   }
  // }

  async changePassword() {
    if (this.password === '' || this.newPassword === '') return;
    if (this.password === this.newPassword) return;
    if (this.newPassword !== this.newPasswordConfirmation) return;

    const out = sjcl.hash.sha256.hash(this.password);
    const hash = sjcl.codec.hex.fromBits(out);

    const newOut = sjcl.hash.sha256.hash(this.newPassword);
    const newHash = sjcl.codec.hex.fromBits(newOut);

    try {
      await api.post('/change-password', {
        oldPassword: hash,
        newPassword: newHash,
      });

      showToast(ToastType.SUCCESS, 'Congratulations', 'Password has been changed');
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      if (error.response?.status === 422) {
        err.response.data.error.errors.forEach((item: ErrorItem) => {
          if (item.reason === 'IncorectPasswordException') {
            showToast(ToastType.FAILED, 'Incorrect Password', 'Invalid Password, please try again.');
          } else {
            showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to check your password');
          }
        });
      } else {
        showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to check your password');
      }
    }
  }

  async getQRCode() {
    const out = sjcl.hash.sha256.hash(this.currentPassword);
    const hash = sjcl.codec.hex.fromBits(out);

    try {
      this.loadingTwoFactor = true;
      const { data } = await api.post('/twofa', {
        password: hash,
      });
      this.qrCode = data.data.qr_code;
      this.loadingTwoFactor = false;
    } catch (err) {
      console.error(err);
      this.loadingTwoFactor = false;
      const error = err as AxiosError;
      if (error.response?.status === 422) {
        err.response.data.error.errors.forEach((item: ErrorItem) => {
          if (item.reason === 'IncorectPasswordException') {
            showToast(ToastType.FAILED, 'Incorrect Password', 'Incorrect password, please try again.');
          } else {
            showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to check your password');
          }
        });
      } else {
        showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to check your password');
      }
    }
  }

  async checkTwoFactorCode() {
    if (!this.twoFactorStatusChanged) return;
    if (!this.twoFactorStatus) {
      this.disableTwoFactor();
      return;
    }

    try {
      await api.post('/verify-twofa', {
        twofaCode: this.twoFactorCode,
      });

      showToast(ToastType.SUCCESS, 'Congratulations', 'Two Factor Authentication has been enabled');
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;
      if (error.response?.status === 401) {
        err.response.data.error.errors.forEach((item: ErrorItem) => {
          if (item.reason === 'InvalidTwoFactorOTP') {
            // showToast(ToastType.FAILED, 'Incorrect Code', 'Invalid Code, please try again.');
            this.errors.twoFactor = 'Invalid Code, please try again.';
          } else {
            showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to check your code');
          }
        });
      } else {
        showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to check your code');
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async disableTwoFactor() {
    try {
      await api.put('/deactivate-twofa');
      showToast(ToastType.SUCCESS, 'Congratulations', 'Two Factor Authentication has been disabled');
    } catch (err) {
      console.error(err);
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to disable two factor authentication');
    }
  }

  async submit() {
    this.loadingSubmit = true;
    await this.changePassword();
    await this.checkTwoFactorCode();
    // await this.updateUser();
    this.loadingSubmit = false;
  }
}
